import { FlexComp, FormattedText, ImageComponent, SpanTag } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";
import { theme } from "@tm/utility/global";

import { TextNodeType } from "../FormattedText/FormattedText";
import { OrderDetailIconWrapper } from "./OrderDetailComp.style";

export interface OrderDetailInsuranceHeaderProps {
  insPlanName?: string | TextNodeType;
  orderDetailIcon?: string;
  insuranceInfo?: string | TextNodeType;
  insuranceType?: string | TextNodeType;
  insuranceTypeColor?: string;
}

const OrderDetailInsuranceHeader = ({
  insPlanName,
  orderDetailIcon,
  insuranceInfo,
  insuranceType,
  insuranceTypeColor,
}: OrderDetailInsuranceHeaderProps) => {
  const device = useBreakpointV2();

  return (
    <FlexComp flexDirection={"row"} justifyContent={"space-between"} gap="8px">
      <FlexComp flexDirection="column" gap="2px" margin="0">
        <SpanTag
          fontSize="xs"
          fontWeight="bold"
          textTransform="uppercase"
          color={insuranceTypeColor}
        >
          <FormattedText value={insuranceType} />
        </SpanTag>

        <SpanTag fontSize={device === "lg" ? "large" : "md"} fontWeight="bold">
          <FormattedText value={insPlanName} />
        </SpanTag>
        <SpanTag
          fontSize={device === "lg" ? "sm" : "xs"}
          color={theme.greyText}
          margin="0 16px 0 0"
        >
          <FormattedText value={insuranceInfo} />
        </SpanTag>
      </FlexComp>

      {orderDetailIcon && (
        <OrderDetailIconWrapper>
          <ImageComponent width="56px" height="56px" src={orderDetailIcon} />
        </OrderDetailIconWrapper>
      )}
    </FlexComp>
  );
};

export default OrderDetailInsuranceHeader;
